const LOGO_URL = 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/698f911cd42cb9ba7c84e7b1/079663cf7_ALIMANLOGO3.jpg';

const LETTERHEAD_HTML = `
  <table style="width:100%;margin-bottom:8px;">
    <tr>
      <td style="width:70px;vertical-align:top;">
        <img src="${LOGO_URL}" style="height:60px;width:60px;object-fit:contain;" />
      </td>
      <td style="text-align:right;vertical-align:top;">
        <div style="font-size:16px;font-weight:bold;letter-spacing:0.5px;">AL-IMAN SOCIETY OF NORTHAMPTONSHIRE</div>
        <div style="font-size:11px;color:#555;margin-top:2px;">A tradition of excellence since 2003</div>
      </td>
    </tr>
  </table>
  <hr style="border:none;border-top:2px solid #222;margin:0 0 15px 0;" />
`;

const FOOTER_HTML = `
  <div style="border-top:1.5px solid #999;padding-top:10px;margin-top:30px;text-align:center;font-size:11px;color:#444;line-height:1.7;">
    <div style="font-weight:bold;font-size:12px;">AL-IMAN SOCIETY OF NORTHAMPTONSHIRE</div>
    <div>Charity number: 1117020</div>
    <div>Northampton Islamic Centre, Clare Street, NORTHAMPTON NN1 3JF</div>
    <div>Tel: 01604633944 &nbsp;|&nbsp; Email: info@al-iman.co.uk &nbsp;|&nbsp; Web: www.al-iman.co.uk</div>
  </div>
`;

export function getLetterhead() { return LETTERHEAD_HTML; }
export function getFooter()     { return FOOTER_HTML; }

export async function downloadPDFFromHTML(html, filename) {
  const fullHTML = `<!DOCTYPE html><html><head>
    <meta charset="UTF-8">
    <title>${filename || 'Document'}</title>
    <style>
      @page { size: A4; margin: 20mm; }
      * { margin:0; padding:0; box-sizing:border-box; }
      body, html {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px; line-height: 1.5; color: #000; background: white;
        -webkit-print-color-adjust: exact; print-color-adjust: exact;
      }
      table { border-collapse: collapse; }
      table, tr, td, th { page-break-inside: avoid; }
      thead { display: table-header-group; }
      h2, h3 { page-break-after: avoid; }
      .page-break { page-break-before: always; }
      @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
    </style>
  </head><body>${html}</body></html>`;

  const win = window.open('', '_blank', 'width=800,height=600');
  if (!win) throw new Error('Pop-up blocked — please allow pop-ups to generate PDFs.');

  win.document.open();
  win.document.write(fullHTML);
  win.document.close();

  await new Promise(resolve => {
    const imgs = win.document.querySelectorAll('img');
    if (imgs.length === 0) { setTimeout(resolve, 300); return; }
    let loaded = 0;
    const check = () => { if (++loaded >= imgs.length) setTimeout(resolve, 300); };
    imgs.forEach(img => { if (img.complete) check(); else { img.onload = check; img.onerror = check; } });
  });

  win.focus();
  win.print();
  setTimeout(() => win.close(), 1200);
}
